import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../src/app/environments/environment';
import { SaldoInicial as SaldoInicialModel } from '../models/saldoInicial.model';

@Injectable({
  providedIn: 'root'
})
export class SaldoInicialService {
  private apiUrl = `${environment.advContabilApi}/api/saldoInicial`;

  constructor(private http: HttpClient) {}

  getSaldoInicial(): Observable<SaldoInicialModel[]> {
    return this.http.get<SaldoInicialModel[]>(`${this.apiUrl}/listar`);
  }

  addSaldoInicial(SaldoInicial: SaldoInicialModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/inserir`, SaldoInicial);
  }

  updateSaldoInicial(SaldoInicial: SaldoInicialModel): Observable<void> {
    return this.http.put<void>(
      `${this.apiUrl}/atualizar/${SaldoInicial.id}`,
      SaldoInicial
    );
  }

  deleteSaldoInicial(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/deletar/${id}`);
  }
}
